import { render, staticRenderFns } from "./wt8AlertWithBook.vue?vue&type=template&id=112af734&scoped=true"
import script from "./wt8AlertWithBook.vue?vue&type=script&lang=js"
export * from "./wt8AlertWithBook.vue?vue&type=script&lang=js"
import style0 from "./wt8AlertWithBook.vue?vue&type=style&index=0&id=112af734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112af734",
  null
  
)

export default component.exports